export default [{
  text: '1er año',
  value: '1'
}, {
  text: '2do año',
  value: '2'
}, {
  text: '3er año',
  value: '3'
}]



//////////////////
// WEBPACK FOOTER
// ./src/data/levels
// module id = RSpm
// module chunks = 1